// extracted by mini-css-extract-plugin
export var compactFilters = "_gd-4";
export var detailImage = "_gd-1";
export var dropdownContainer = "_gd-2";
export var imageContainer = "_gd-0";
export var selectedCard = "_gd-3";